import { Checkbox } from '@repo/ui/Checkbox';

export const EnabledCheckbox = ({
  label,
  checked,
  disabled,
}: {
  label?: string;
  checked: boolean | undefined;
  disabled?: boolean;
}) => {
  return (
    <Checkbox
      checked={checked}
      label={label ? label : checked ? 'Enabled' : 'Disabled'}
      noFocus
      disabled={disabled}
    />
  );
};
